import { FormatDateForDisplay } from "./data-utils";

export const CalculateCurrentGestation = (startDate: string | undefined, weeksAtStart: string | undefined) =>
{
  if (startDate === undefined || startDate === null || startDate.length === 0 || 
      weeksAtStart === undefined || weeksAtStart === null || weeksAtStart.length === 0) {
    return "-";
  }

  const today = new Date().getTime();
  const started = new Date(startDate).getTime();
  const diffInMs = today - started;
  
  const aDayInMs = 24 * 60 * 60 * 1000;
  var daysDiff = Math.round(diffInMs / aDayInMs);
  daysDiff++;
  const elapsedWeeks = Math.floor(daysDiff / 7);
  // var partWeeks = daysDiff % 7;
  // if (partWeeks > 0) weeks++;
  const startingWeeks = parseInt(weeksAtStart);
  return startingWeeks + elapsedWeeks;
}

export const CalculateDiagnosisDate = (startDate: string | undefined, weeksAtStart: string | undefined, weekAtDiagnosis: string | undefined) =>
{
  if (weeksAtStart === undefined || weeksAtStart === null || weeksAtStart.length === 0 || 
    weekAtDiagnosis === undefined || weekAtDiagnosis === null || weekAtDiagnosis.length === 0 ) {
    return "-";
  }

  var gestationDays = Number(weeksAtStart) *7;
  var diabetesDays = Number(weekAtDiagnosis) *7;

  let programStarted;
  if (startDate === undefined || startDate === null || startDate.length === 0)
    programStarted = new Date();
  else
    programStarted = new Date(startDate);

  const dayZero = programStarted.getTime() - (gestationDays * 24 * 60 * 60 * 1000);
  const dayDiagnosed = dayZero + (diabetesDays * 24 * 60 * 60 * 1000);
  programStarted.setTime(dayDiagnosed);
  var displayDate = programStarted.toISOString();
  return FormatDateForDisplay(displayDate);
}

export const LastReviewedDate = (dateStr: string) => {
  const formattedDate = FormatDateForDisplay(dateStr);
  if(formattedDate?.length === 0)
  {
    return "N/A";
  }
  return formattedDate;
}

export const CalculateBMI = (heightInCm: string, weightInKg: string) => {
  if(heightInCm == null || heightInCm.length === 0 || weightInKg == null || weightInKg.length === 0)
    return;

  var height = parseInt(heightInCm);
  let weight = parseFloat(weightInKg);
  height = Math.pow(height/100, 2);
  
  return Math.round(weight/height);
}

export const CalculateWeightMetrics = (heightInCm:string, weightInKg:string): [number, string] => {

  if(heightInCm == null || heightInCm.length === 0 || weightInKg == null || weightInKg.length === 0)
    return [0,"N/A"];

  var height = parseInt(heightInCm);
  let weight = parseFloat(weightInKg);
  height = Math.pow(height/100, 2);
  
  var gwg = "5-9Kg";
  var bmi = Math.round(weight/height);
  if(bmi < 18.5)
    gwg = "12.5-18Kg";
  else if(bmi >= 18.5 && bmi <= 24.9)
    gwg = "11.5-16Kg";
  else if(bmi > 24.9 && bmi <= 29.9)
    gwg = "7-11.5Kg";

  return [bmi,gwg];
}